import * as numeral from 'numeral';
import 'numeral/locales/pt-br';

export const lineChartOptions: any = {
  legend: {
    display: true,
  },
  scaleShowVerticalLines: false,
  elements: {
    line: {
      fill: false,
      tension: 0, // disables bezier curves
      borderDash: [],
      borderCapStyle: 'butt',
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter'
    },
    point: {
      backgroundColor: '#FFFFFF',
      borderWidth: 1,
      hoverRadius: 5,
      hoverBorderWidth: 2,
      radius: 5,
      hitRadius: 10
    }
  },
  scales: {
    xAxes: [{
      gridLines: {
        display: true
      }
    }],
    yAxes: [{
      gridLines: {
        display: true
      },
      ticks: {
        beginAtZero: true,
        // Include a dollar sign in the ticks
        callback: (value, index, values) => {
            return numeral(value * 60).format('00:00:00');
        }
      }
    }]
  },
  tooltips: {
    callbacks: {
      label: (tooltipItem, data) => {
        const allData = data.datasets[tooltipItem.datasetIndex].data;
        const tooltipLabel = data.labels[tooltipItem.index];
        const tooltipData = allData[tooltipItem.index];
        const dataLabel = data.datasets[tooltipItem.datasetIndex].label;

        return `${ dataLabel }: ${ numeral(tooltipData * 60).format('00:00:00') }`;
      }
    }
  }
};
